import { GoogleReview } from "../types/googleReview";

export const defaultGoogleReview: GoogleReview = {
  rating: 0,
  author_name: "",
  text: "",
  authorUrl: "",
  time: 0,
};

export const googleReviewMaxRating = (): number => {
  return 5;
};
export const getGoogleReviewFormattedTime = (review: GoogleReview): string => {
  // clientとseverでずれるのでutcで統一
  const date: Date = new Date(review.time * 1000);
  date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
  const month: string = `0${date.getMonth() + 1}`.slice(-2);
  const day: string = `0${date.getDate()}`.slice(-2);
  return `${date.getFullYear()}/${month}/${day}`;
};
